import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { publicRoutes } from "./allRoutes";

// Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";

const Index = () => {
  return (
    <Suspense fallback={<div className="text-center mt-5">Loading...</div>}>
      <Routes>
        {/* Public Layout */}
        <Route element={<NonAuthLayout />}>
          {publicRoutes.map((route, idx) => (
            <Route key={idx} path={route.path} element={route.component} />
          ))}
          <Route index element={<Navigate to="/lead/form" />} />
          <Route path="*" element={<Navigate to="/lead/form" />} />
        </Route>

      </Routes>
    </Suspense>
  );
};

export default Index;
